define("shared/components/shared/addon-details-card/upcoming-plan", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="tAC--addonCard" ...attributes>
    {{svg-jar "arrow-right" class="o--icon u--m__r"}}
    <div>
      <div>{{@title}}</div>
      {{#if @description}}
        <span class="u--text--base">
          {{@description}}
        </span>
      {{/if}}
    </div>
  </div>
  */
  {
    "id": "hFkgzzYH",
    "block": "[[[11,0],[24,0,\"tAC--addonCard\"],[17,1],[12],[1,\"\\n  \"],[1,[28,[35,0],[\"arrow-right\"],[[\"class\"],[\"o--icon u--m__r\"]]]],[1,\"\\n  \"],[10,0],[12],[1,\"\\n    \"],[10,0],[12],[1,[30,2]],[13],[1,\"\\n\"],[41,[30,3],[[[1,\"      \"],[10,1],[14,0,\"u--text--base\"],[12],[1,\"\\n        \"],[1,[30,3]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"&attrs\",\"@title\",\"@description\"],false,[\"svg-jar\",\"if\"]]",
    "moduleName": "shared/components/shared/addon-details-card/upcoming-plan.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});